import ForgetPwd from '../Components/Pages/Auth/ForgetPwd';
import RegisterSimple from '../Components/Pages/Auth/RegisterSimple';
import Logins from '../Auth/Signin';
import MerchantDetails from '../Components/Pages/MerchantDetails';
import PrivacyPolicyPage from '../Components/Pages/Privacy/PrivacyPolicyPage';
import ContactUsPage from '../Components/Pages/Contact/ContactusPage';

export const authRoutes = [
  { path: `/login`, Component: <Logins /> },
  { path: `/privacy-policy`, Component: <PrivacyPolicyPage /> },
  { path: `/contact-us`, Component: <ContactUsPage /> },
  { path: `/register`, Component: <RegisterSimple /> },
  { path: `/pages/authentication/forget-password/`, Component: <ForgetPwd /> },
  { path: `/merchant/details/:edit?`, Component: < MerchantDetails /> },
];
